import React, {useState} from 'react'
import Select from 'react-select'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useSelector} from 'react-redux'
import {RootState} from '../../../redux/store'
import {useInterpreters} from '../../../hooks/useGlobalData'
import type {OpiFilters} from './_requests'

type Option = {value: string; label: string}

type Props = {
  onApply: (filters: OpiFilters) => void
  isLoading: boolean
}

const selectStyles = {
  control: (provided: any) => ({
    ...provided,
    minWidth: 0,
    width: '100%',
    border: '1px solid #dee1e6',
    minHeight: 38,
    fontSize: 14,
  }),
}

const icon = (name: string) => (
  <img
    src={toAbsoluteUrl(`/media/icons/opi/${name}.svg`)}
    alt=''
    style={{width: 16, height: 16, marginRight: 6}}
  />
)

const todayStr = () => {
  const d = new Date()
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export const OpiFilterBar: React.FC<Props> = ({onApply, isLoading}) => {
  const {items: customers} = useSelector((state: RootState) => state.customers)
  const {items: languages} = useSelector((state: RootState) => state.languages)
  const {data: interpreters} = useInterpreters()

  const customerOptions: Option[] = (customers ?? []).map((c: any) => ({
    value: String(c.key ?? ''),
    label: c.value ?? '',
  }))
  const languageOptions: Option[] = (languages ?? []).map((l: any) => ({
    value: String(l.key ?? ''),
    label: l.value ?? '',
  }))
  const interpreterOptions: Option[] = (interpreters ?? []).map((i: any) => ({
    value: String(i.key ?? ''),
    label: i.value ?? '',
  }))

  const [date, setDate] = useState(todayStr())
  const [startTime, setStartTime] = useState('05:00')
  const [endTime, setEndTime] = useState('15:00')
  const [selectedLangs, setSelectedLangs] = useState<Option[]>([])
  const [selectedInterpreters, setSelectedInterpreters] = useState<Option[]>([])
  const [selectedCustomers, setSelectedCustomers] = useState<Option[]>([])

  const handleApply = () => {
    onApply({
      date: date || undefined,
      startTime: startTime || undefined,
      endTime: endTime || undefined,
      languages: selectedLangs.map((o) => o.value),
      interpreters: selectedInterpreters.map((o) => o.value),
      customers: selectedCustomers.map((o) => Number(o.value)).filter((n) => !Number.isNaN(n)),
    })
  }

  return (
    <div className='opi-filter-bar'>
      <div className='opi-filter-bar__field'>
        <label>{icon('calendar')}Date</label>
        <input
          type='date'
          className='form-control'
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
      </div>
      <div className='opi-filter-bar__field'>
        <label>{icon('clock')}Start Time</label>
        <input
          type='time'
          className='form-control'
          value={startTime}
          onChange={(e) => setStartTime(e.target.value)}
        />
      </div>
      <div className='opi-filter-bar__field'>
        <label>{icon('clock')}End Time</label>
        <input
          type='time'
          className='form-control'
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
        />
      </div>
      <div className='opi-filter-bar__field'>
        <label>{icon('language')}All Languages</label>
        <Select
          isMulti
          className='react-select-styled react-select-solid react-select-sm'
          classNamePrefix='opi-select'
          options={languageOptions}
          value={selectedLangs}
          onChange={(v: any) => setSelectedLangs((v as Option[]) ?? [])}
          styles={selectStyles}
          placeholder='All Languages'
        />
      </div>
      <div className='opi-filter-bar__field'>
        <label>{icon('interpreter')}All Interpreters</label>
        <Select
          isMulti
          className='react-select-styled react-select-solid react-select-sm'
          classNamePrefix='opi-select'
          options={interpreterOptions}
          value={selectedInterpreters}
          onChange={(v: any) => setSelectedInterpreters((v as Option[]) ?? [])}
          styles={selectStyles}
          placeholder='All Interpreters'
        />
      </div>
      <div className='opi-filter-bar__field'>
        <label>{icon('customer')}All Customers</label>
        <Select
          isMulti
          className='react-select-styled react-select-solid react-select-sm'
          classNamePrefix='opi-select'
          options={customerOptions}
          value={selectedCustomers}
          onChange={(v: any) => setSelectedCustomers((v as Option[]) ?? [])}
          styles={selectStyles}
          placeholder='All Customers'
        />
      </div>
      <button
        type='button'
        className='opi-filter-bar__apply'
        disabled={isLoading}
        onClick={handleApply}
      >
        Apply
      </button>
    </div>
  )
}
